import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Slide
} from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { createInventory, updateInventory } from '../api/apiInventory';
import WrappedTextField from 'common/components/custom/WrappedTextField';
import WrappedFromControlLabel from 'common/components/custom/WrappedFromControlLabel';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class CreateOrUpdateInventory extends Component {

    emptyInventory = {
        isActive: true,
        inventoryName: '',
        inventoryDescription: ''
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            initialInventory: JSON.parse(JSON.stringify(this.emptyInventory)),
            inventory: JSON.parse(JSON.stringify(this.emptyInventory)),
            modelToDelete: JSON.parse(JSON.stringify(this.emptyInventory)),
            selectedClient: null
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.inventoryToEdit != null) {
            if (prevState.inventory.id !== this.props.inventoryToEdit.id) {
                this.setState({ inventory: this.props.inventoryToEdit, initialInventory: JSON.parse(JSON.stringify(this.props.inventoryToEdit)) });
            }
        }
    }

    closeDialog = () => {
        this.props.onClose();
        this.setState({
            inventory: this.emptyInventory
        });
    }

    handleChangeClient = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client })
        } else {
            this.setState({ selectedClient: null })
        }
    }

    handleChange = (event) => {
        let { inventory } = this.state
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        inventory[name] = value;
        this.setState({ inventory: inventory })
    };


    createOrUpdateInventory = (e) => {
        e.preventDefault();
        const { inventory } = this.state;

        if (!this.validateForm()) {
            return;
        }

        const requestBodyCreate = {
            ...this.state.inventory,
            clientId: this.props.selectedClient.id
        }

        let action = this.props.inventoryToEdit ? updateInventory : createInventory
        action(this.props.inventoryToEdit ? inventory : requestBodyCreate).then(response => {
            this.props.enqueueSnackbar(
                this.props.t(this.props.inventoryToEdit ? 'update_message_inventory' : 'create_message_inventory'), { variant: 'success' });
            this.closeDialog()
            this.props.getInventories()
        }).catch(error => {
            if (error.response.status === 400) {
                this.props.enqueueSnackbar(this.props.t("inventory_already_exists"), { variant: 'warning' });
            } else {
                this.props.enqueueSnackbar(
                    this.props.t(this.props.inventoryToEdit ? 'error_update_message' : 'error_create_message', { title: this.props.t('inventory') }), { variant: 'error' });
            }
        });
    };

    validateForm() {
        let { inventory } = this.state;
        let valid = true;
        if (!inventory.inventoryName || !inventory.inventoryDescription
        ) {
            valid = false;
        }
        return valid;
    }

    render() {
        let { inventory, initialInventory } = this.state

        return (
            <Dialog open={this.props.isOpen} TransitionComponent={Transition}>
                <DialogTitle className="dialog-header-custom" onClose={this.closeDialog}>{this.props.inventoryToEdit ? this.props.t("edit_inventory") : this.props.t("new_inventory")}</DialogTitle>
                <form onSubmit={this.createOrUpdateInventory} autoComplete="off" spellCheck="false">
                    <DialogContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"inventory_name"}
                                            name="inventoryName"
                                            onChange={this.handleChange}
                                            value={inventory.inventoryName}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"inventory_description"}
                                            name="inventoryDescription"
                                            onChange={this.handleChange}
                                            value={inventory.inventoryDescription}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedFromControlLabel
                                                onChange={this.handleChange}
                                                name="isActive"
                                                checked={inventory.isActive}
                                                label={"active"}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent >
                    <DialogActions className={"dialog-actions-fix"}>
                        <Button color="inherit" onClick={this.closeDialog} variant="contained">
                            {this.props.t("close")}
                        </Button>
                        <Button type="submit" color="primary" variant="contained" disabled={this.props.inventoryToEdit ? (JSON.stringify(inventory) === JSON.stringify(initialInventory)) : !this.validateForm()}>
                            {this.props.inventoryToEdit ? this.props.t("update") : this.props.t("create")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog >
        );
    }
}

export default withSnackbar(withRouter(withTranslation()(CreateOrUpdateInventory)));
